<template>
    <div id="commandment-file" ref="contract"
        style="line-height: 2; width: 100%">
        <section slot="pdf-content" contenteditable="true">
            <div class="col-md-12">
                <div class="info-block">
                    <div style="text-align: center; font-weight: 700">ԱՊՐԱՆՔԻ ՄԱՏԱԿԱՐԱՐՄԱՆ ՊԱՅՄԱՆԱԳԻՐ</div>
                    <div style="text-align: center; font-weight: 700">N<span class="contract-code" style="color: rgb(17, 85, 204);"> {{ currentOrganized.code }}</span></div>
                    <br>
                    <table style="width: 100%; border: none !important">
                        <tbody>
                            <tr>
                                <td style="border:none !important;" class="ft-11">
                                     <span style="color: rgb(17, 85, 204);">{{ me.organisation[0].translations.city.hy }}</span>
                                </td>
                                <td class="ft-11"  style="border:none !important; text-align: right; float: right">
                                    <span style="color: rgb(17, 85, 204);" class="sign-date">__.__.____</span>թ.
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <br>
                    <div style="text-align: justify">
                        <span style="color: rgb(17, 85, 204);">«{{ me.organisation[0].translations.name.hy }}» {{ me.organisation[0].translations.company_type.hy }}</span>-ը, ի դեմս
                        տնօրեն <span style="color: rgb(17, 85, 204);">{{ me.organisation[0].translations.director_name.hy }}</span>-ի, որը գործում է 
                        <span style="color: rgb(17, 85, 204);">«{{ me.organisation[0].translations.name.hy }}» {{ me.organisation[0].translations.company_type.hy }}</span>
                        կանոնադրության հիման վրա (այսուհետ՝ Գնորդ), մի կողմից, և  
                        <span class="winner-name">_______</span>-ն, ի դեմս տնօրեն<span class="winner-director">_______</span>ի, 
                        որը գործում է <span class="winner-name">_______</span> կանոնադրության հիման վրա (այսուհետ՝ Վաճառող), մյուս կողմից,
                        կնքեցին սույն պայմանագիրը հետևյալի մասին։
                    </div>
                </div>
                <br/>
                <div style="font-weight: 700; text-align: center;">1. ՊԱՅՄԱՆԱԳՐԻ ԱՌԱՐԿԱՆ</div>
                <br>
                <div class="info-block">
                    <div style="text-align: justify;">
                        <span style="margin-left: 25px;"/>1.1. Վաճառողը պարտավորվում է սույն պայմանագրով (այսուհետ` պայմանագիր) սահմանված կարգով, ծավալներով, ժամկետներում և հասցեով Գնորդին մատակարարել պայմանագրի N 1 հավելվածով` Տեխնիկական բնութագիր-գնման-ժամանակացույցով նախատեսված ապրանքը (այսուհետ` ապրանք), իսկ Գնորդը պարտավորվում է ընդունել ապրանքը և վճարել դրա համար։
                    </div>
                </div>
                <br/>
                <div style="font-weight: 700; text-align: center;">2. ԿՈՂՄԵՐԻ ԻՐԱՎՈՒՆՔՆԵՐԸ ԵՎ ՊԱՐՏԱԿԱՆՈՒԹՅՈՒՆՆԵՐԸ</div>
                <br>
                <div class="info-block">
                    <div style="text-align: justify;">
                        <span style="margin-left: 25px;"/><span style="font-weight: 700">2.1 Գնորդն իրավունք ունի`</span>
                        <br/><span style="margin-left: 25px;"/>
                        2.1.1 Ապրանքը պայմանագրով սահմանված ժամկետում Վաճառողի կողմից չմատակարարելու դեպքում հրաժարվել ապրանքից, եթե մատակարարման ժամկետները խախտվել են 
                        <input type="text"
                            class="editor-input"
                            v-model="$v.inputs.violationDays.$model"
                            ref="violationDays"
                            inputName="violationDays"
                            style="width: 30px;border-top: 0 !important; border-left: 0 !important; border-right: 0 !important;text-align: right;   
                            font-size: 13px;
                            color: #303e67;
                            border-bottom: 1px solid black" 
                        /> 
                        օրից ավելի:
                        <br/><span style="margin-left: 25px;"/>2.1.2 Եթե հանձնվել է անպատշաճ որակի` պայմանագրով նախատեսված տեխնիկական բնութագրին չհամապատասխանող ապրանք`
                        <br/><span style="margin-left: 25px;"/>ա) պահանջել հատուցելու ապրանքի անպատշաճ որակի լինելու պատճառով իր կատարած ծախսերը.
                        <br/><span style="margin-left: 25px;"/>բ) չընդունել ապրանքն` իր հայեցողությամբ սահմանելով անպատշաճ որակի ապրանքը պայմանագրին համապատասխանող որակի ապրանքով անհատույց փոխարինման ողջամիտ ժամկետ և պահանջել Վաճառողից վճարելու պայմանագրի 6.3 կետով նախատեսված տուգանքը.
                        <br/><span style="margin-left: 25px;"/>գ) հրաժարվել պայմանագիրը կատարելուց և պահանջել վերադարձնելու ապրանքի համար վճարված գումարը:
                        <br/><span style="margin-left: 25px;"/>2.1.3. Եթե հանձնվել է պայմանագրով որոշվածից պակաս քանակի ապրանք, ապա`
                        <br/><span style="margin-left: 25px;"/>ա) պահանջել լրացնելու ապրանքի պակաս հանձնված քանակը,
                        <br/><span style="margin-left: 25px;"/>բ) հրաժարվել հանձնված ապրանքից և դրա համար վճարելուց, իսկ եթե ապրանքի համար վճարվել է, ապա պահանջել վերադարձնելու վճարված գումարը և վճարելու պայմանագրի 6.2 կետով նախատեսված տույժը:
                        <br/><span style="margin-left: 25px;"/>2.1.4. Եթե հանձնվել է տեսակի պայմանի խախտմամբ ապրանք,  իր ընտրությամբ`
                        <br/><span style="margin-left: 25px;"/>ա) ընդունել տեսակի վերաբերյալ պայմանին համապատասխանող ապրանքը և հրաժարվել մնացած ապրանքներից.
                        <br/><span style="margin-left: 25px;"/>բ) հրաժարվել հանձնված բոլոր ապրանքներից և պահանջել վճարելու պայմանագրի 6.2 կետով նախատեսված տույժը.
                        <br/><span style="margin-left: 25px;"/>գ) պահանջել տեսակի վերաբերյալ պայմանին չհամապատասխանող ապրանքի անհատույց փոխարինում պայմանագրով նախատեսված տեսակին համապատասխան ապրանքով:
                        <br/><span style="margin-left: 25px;"/>2.1.5. Վաճառողի կողմից մատակարարման ժամկետների խախտման դեպքում իր հայեցողությամբ սահմանել ապրանքի մատակարարման նոր ժամկետ և պահանջել Վաճառողից վճարելու պայմանագրի  6.2 կետով նախատեսված տույժը։
                        <br/><span style="margin-left: 25px;"/>2.1.6. Վաճառողից պահանջել հատուցելու վնասները, եթե Գնորդը Վաճառողի կողմից պարտավորությունը խախտելու հետևանքով պայմանագրի լուծումից հետո ողջամիտ ժամկետում այլ անձից ավելի բարձր, սակայն ողջամիտ գնով գնել է ապրանք` պայմանագրով նախատեսվածի փոխարեն` պայմանագրով սահմանված և դրա փոխարեն կնքված գործարքի գների միջև տարբերության չափով, ինչպես նաև ապրանքն այլ անձից ձեռք բերելու համար իր կատարած բոլոր անհրաժեշտ և ողջամիտ ծախսերը:
                        <br/><span style="margin-left: 25px;"/>2.1.7. Միակողմանի լուծել պայմանագիրը (լրիվ կամ մասնակի), եթե Վաճառողն էականորեն խախտել է պայմանագիրը.
                        <br/><span style="margin-left: 25px;"/>2.1.7.1. Վաճառողի կողմից պայմանագիրը խախտելն էական է համարվում, եթե`
                        <br/><span style="margin-left: 25px;"/><span style="margin-left: 25px;"/>ա) մատակարարվել է անպատշաճ որակի ապրանք որը չի կարող փոխարինվել Գնորդի համար ընդունելի ժամկետում.
                        <br/><span style="margin-left: 25px;"/><span style="margin-left: 25px;"/>
                        բ) ապրանքի մատակարարման ժամկետները խախտվել են
                        <input type="text"
                            class="editor-input"
                            v-model="$v.inputs.violationDays_1.$model"
                            ref="violationDays_1"
                            inputName="violationDays_1"
                            style="width: 30px;border-top: 0 !important; border-left: 0 !important; border-right: 0 !important;text-align: right;   
                            font-size: 13px;
                            color: #303e67;
                            border-bottom: 1px solid black"  
                        /> օրից ավելի,
                        <br/><span style="margin-left: 25px;"/>2.1.8. Զննել ապրանքը և հայտնաբերված թերությունների մասին անհապաղ տեղեկացնել Վաճառողին։
                    </div>
                    <br>
                    <div style="text-align: justify;">
                        <span style="margin-left: 25px;"/><span style="font-weight: 700">2.2 Գնորդը պարտավոր է`</span>
                        <br/><span style="margin-left: 25px;"/>2.2.1 Կատարել պայմանագրին համապատասխան մատակարարված ապրանքի ընդունումն ապահովող բոլոր անհրաժեշտ գործողությունները:
                        <br/><span style="margin-left: 25px;"/>2.2.2 Վաճառողի հանձնած ապրանքից պայմանագրին համապատասխան հրաժարվելու դեպքում, ապահովել այդ ապրանքի պատասխանատու պահպանությունը և դրա մասին անհապաղ տեղեկացնել Վաճառողին:
                        <br/><span style="margin-left: 25px;"/>2.2.3. Պայմանագրով նախատեսված կարգով և ժամկետներում մատակարարված ապրանքն ընդունելու դեպքում Վաճառողին վճարել վերջինիս վճարման ենթակա գումարները, իսկ վճարման ժամկետի խախտման դեպքում` նաև պայմանագրի  6.5 կետով նախատեսված տույժը։
                        <br/><span style="margin-left: 25px;"/>2.2.4. Ապրանքի քանակի, տեսականու, որակի մասին պայմանագրի պայմանները խախտելու մասին Վաճառողին ծանուցել թերությունը հայտնաբերելուց հետո անմիջապես կամ այն բանից հետո` ողջամիտ ժամկետում, երբ պայմանագրի համապատասխան պայմանի խախտումը պետք է հայտնաբերված լիներ` ելնելով ապրանքի բնույթից և նշանակությունից։
                        <br/><span style="margin-left: 25px;"/>2.2.5. Պայմանագրի 2.3.3 կետի համաձայն պայմանագրի լուծումից հետո Վաճառողին հատուցել վերջինիս պատճառված և սահմանված կարգով հիմնավորված վնասները։
                    </div>
                    <br>
                    <div style="text-align: justify;">
                        <span style="margin-left: 25px;"/><span style="font-weight: 700">2.3 Վաճառողն իրավունք ունի`</span>
                        <br/><span style="margin-left: 25px;"/>2.3.1. Գնորդից պահանջել ընդունելու պայմանագրով նախատեսված կարգով, ծավալներով, ժամկետներում և հասցեով մատակարարված ապրանքը:
                        <br/><span style="margin-left: 25px;"/>2.3.2. Գնորդից պահանջել վճարելու պայմանագրով նախատեսված կարգով, ծավալներով, ժամկետներում և հասցեով մատակարարված և Գնորդի կողմից ընդունված ապրանքի համար իրեն վճարման ենթակա գումարները:
                        <br/><span style="margin-left: 25px;"/>2.3.3. Միակողմանի լուծել պայմանագիրը (լրիվ կամ մասնակի), եթե Գնորդն էականորեն խախտել է պայմանագիրը:
                        <br/><span style="margin-left: 25px;"/>2.3.3.1. Գնորդի կողմից պայմանագիրը խախտելն էական է համարվում, եթե բազմիցս խախտվել են ապրանքի համար վճարելու ժամկետները։
                        <br/><span style="margin-left: 25px;"/>2.3.4. Գնորդի համաձայնությամբ վաղաժամկետ մատակարարել ապրանքը։
                    </div>
                    <br>
                    <div style="text-align: justify;">
                        <span style="margin-left: 25px;"/><span style="font-weight: 700">2.4 Վաճառողը պարտավոր է`</span>
                        <br/><span style="margin-left: 25px;"/>2.4.1. Գնորդին հանձնել ապրանքը` պայմանագրով նախատեսված կարգով, ծավալներով, ժամկետներում և հասցեով:
                        <br/><span style="margin-left: 25px;"/>2.4.2. Ապահովել ապրանքի մատակարարումը պայմանագրի 2.1.2 կետի բ) ենթակետին և (կամ) 2.1.5 կետին համապատասխան` Գնորդի կողմից սահմանված ժամկետներում: 
                        <br/><span style="margin-left: 25px;"/>2.4.3. Գնորդին հանձնել երրորդ անձանց իրավունքներից ազատ ապրանք:
                        <br/><span style="margin-left: 25px;"/>2.4.4. Գնորդին հանձնել պայմանագրով նախատեսված որակի և քանակի ապրանք` պայմանագրով նախատեսված ժամկետներում և հասցեով, իսկ Գնորդի պահանջով տրամադրել ապրանքի որակը հավաստող` ՀՀ օրենսդրությամբ սահմանված փաստաթղթեր։
                        <br/><span style="margin-left: 25px;"/>2.4.5. Թերի մատակարարում թույլ տալու դեպքում, պայմանագրով նախատեսված կարգով, լրացնել թերի մատակարարվածը։
                        <br/><span style="margin-left: 25px;"/>2.4.6. Հետ տանել Գնորդի կողմից պայմանագրի 2.2.2 կետին համապատասխան` պատասխանատու պահպանության ընդունված ապրանքը կամ ողջամիտ ժամկետում տնօրինել այն, ինչպես նաև հատուցել ապրանքը պատասխանատու պահպանության ընդունելու, այն իրացնելու կամ Վաճառողին վերադարձնելու հետ կապված անհրաժեշտ ծախսերը։
                        <br/><span style="margin-left: 25px;"/>2.4.7. Պայմանագրով նախատեսված դեպքերում վճարել պայմանագրի 6.2 և 6.3  կետերով նախատեսված տույժը և տուգանքը։
                        <br/><span style="margin-left: 25px;"/>2.4.8. Գնորդին հանձնել ապրանքի պատկանելիքները և համապատասխան փաստաթղթերը։
                        <br/><span style="margin-left: 25px;"/>2.4.9. Պայմանագրի 2.1.7 կետի համաձայն պայմանագրի լուծումից հետո Գնորդին հատուցել վերջինիս պատճառված և սահմանված կարգով հիմնավորված վնասները։
                    </div>
                </div>
                <br/>
                <div style="font-weight: 700; text-align: center;">3. ՊԱՅՄԱՆԱԳՐԻ ԳԻՆԸ ԵՎ ՎՃԱՐՄԱՆ ԿԱՐԳԸ</div>
                <br>
                <div class="info-block">
                    <div style="text-align: justify;">
                        <span style="margin-left: 25px;"/>3.1. Պայմանագրի գինը կազմում է <span class="contract-price">_______</span> (<span class="contract-price-word">______________</span>) ՀՀ դրամ <span class="contract-det"></span> 
                        <br/><span style="margin-left: 25px;"/>Պայմանագրի գինը ներառում է պայմանագրի կատարումն ապահովելու նպատակով Վաճառողի կողմից կատարվելիք բոլոր վճարները (ծախսերը), այդ թվում` հարկերը, տուրքերը, փոխադրման, ապահովագրման ծախսերը, պարգևավճարները և ակնկալվող շահույթը
                        <span class="if-phys-person">, ընդ որում` հարկային պարտավորությունները (հարկեր և պարտադիր այլ վճարներ) վճարվում են հարկային գործակալի` Գնորդի կողմից</span>:
                        Ապրանքի մատակարարման գինը կայուն է և Վաճառողն իրավունք չունի պահանջել ավելացնելու, իսկ Գնորդը նվազեցնելու այդ գինը։
                        <template v-if="+currentOrganized.prepayment">
                            <span style="margin-left: 25px;"/>3.1.1. Պայմանագրի գնից` մինչև {{ currentOrganized.prepayment_max }} ({{ currentOrganized.prepayment_max_text }}) ՀՀ դրամը, Գնորդը փոխանցում է Վաճառողի բանկային հաշվին` որպես կանխավճար։ Կանխավճարի մարումն իրականացվում է հանձնման-ընդունման արձանագրությունների հիման վրա կատարվող վճարումներից նվազեցումներ (պահումներ) կատարելու ձևով։ Ընդ որում մինչև կանխավճարի ամբողջական մարումը, Վաճառողին վճարումներ չեն կատարվում:
                        </template>
                        <br/><span style="margin-left: 25px;"/>3.2. Գնորդն իրեն մատակարարված ապրանքի դիմաց վճարում է ՀՀ դրամով անկանխիկ` դրամական միջոցները Վաճառողի հաշվարկային հաշվին փոխանցելու միջոցով։ Դրամական միջոցների փոխանցումը կատարվում է հանձման-ընդունման արձանագրության հիման վրա` պայմանագրի վճարման  ժամանակացույցով (հավելված N 2) նախատեսված չափերով և ամիսներին:
                    </div>
                </div>
                <br/>
                <div style="font-weight: 700; text-align: center;">4. ԱՊՐԱՆՔԻ ՈՐԱԿԸ ԵՎ ԵՐԱՇԽԻՔԸ</div>
                <br>
                <div class="info-block">
                    <div style="text-align: justify;">
                        <span style="margin-left: 25px;"/>4.1. Վաճառողը երաշխավորում է մատակարարված ապրանքի որակի համապատասխանությունը պետական ստանդարտի պահանջներին։
                        <br/><span style="margin-left: 25px;"/>
                        4.2. <span style="color: rgb(17, 85, 204);">Հիմնական միջոց</span> հանդիսացող ապրանքների համար երաշխիքային ժամկետ է սահմանվում Գնորդի կողմից ապրանքն ընդունվելու օրվան հաջորդող օրվանից հաշված 
                        <input type="text"
                            class="editor-input"
                            v-model="$v.inputs.violationDays_2.$model"
                            ref="violationDays_2"
                            inputName="violationDays_2"
                            style="width: 30px;border-top: 0 !important; border-left: 0 !important; border-right: 0 !important; text-align: right;   
                            font-size: 13px;
                            color: #303e67;
                            border-bottom: 1px solid black" 
                        />
                        օրացուցային օրը:  Եթե երաշխիքային ժամկետի ընթացքում ի հայտ են եկել մատակարարված ապրանքի թերություններ, ապա Վաճառողը պարտավոր է իր հաշվին, Գնորդի կողմից սահմանված ողջամիտ ժամկետում վերացնել թերությունները
                    </div>
                </div>
                <br/>
                <div style="font-weight: 700; text-align: center;">5. ԱՊՐԱՆՔԻ ՀԱՆՁՆՈՒՄԸ ԵՎ ԸՆԴՈՒՆՈՒՄԸ</div>
                <br>
                <div class="info-block">
                    <div style="text-align: justify;">
                        <template >
                                <span style="margin-left: 25px;"/>5.1 Մատակարարված ապրանքն ընդունվում է Գնորդի և Վաճառողի միջև հանձնման-ընդունման արձանագրության ստորագրմամբ: Ապրանքը Գնորդին հանձնելու փաստը ֆիքսվում է Գնորդի և Վաճառողի միջև երկկողմ հաստատված փաստաթղթով՝ նշելով փաստաթղթի կազմման ամսաթիվը:
                                <br/><span style="margin-left: 25px;"/>Մինչև պայմանագրով ապրանքի մատակարարման համար նախատեսված օրը ներառյալ Վաճառողը Գնորդին է տրամադրում իր կողմից ստորագրված
                                <span style="color: rgb(17, 85, 204);">ապրանքը Գնորդին հանձնելու փաստը ֆիքսող փաստաթուղթը (հավելված N 3.1) և հանձնման-ընդունման արձանագրության օրինակ (հավելված N 3): 
                                <br/><span style="margin-left: 25px;"/>5.2 Հանձնման-ընդունման արձանագրությունը ստորագրվում է, եթե մատակարարված ապրանքը համապատասխանում է պայմանագրի պայմաններին։ Հակառակ դեպքում պայմանագրի կամ դրա մի մասի կատարման արդյունքները չեն ընդունվում, հանձնման-ընդունման արձանագրությունը չի ստորագրվում և Գնորդը</span>
                                <br/><span style="margin-left: 50px;"/>ա) հարցի կարգավորման համար ձեռնարկում է նման իրավիճակի համար պայմանագրով նախատեսված միջոցները.
                                <br/><span style="margin-left: 50px;"/>բ) Վաճառողի նկատմամբ կիրառում է պայմանագրով նախատեսված պատասխանատվության միջոցներ։
                                <br/><span style="margin-left: 25px;"/>5.3 Գնորդը հանձնման-ընդունման արձանագրությունը ստանալու օրվան հաջորդող աշխատանքային օրվանից հաշված 
                                <input type="text"
                                    class="editor-input"
                                    v-model="$v.inputs.daysCount.$model"
                                    ref="daysCount"
                                    inputName="daysCount"
                                    style="width: 30px;border-top: 0 !important; border-left: 0 !important; border-right: 0 !important; text-align: right;   
                                    font-size: 13px;
                                    color: #303e67;
                                    border-bottom: 1px solid black"
                                    onkeypress="this.style.width = ((this.value.length + 1) * 8 + 2) + 'px';"
                                />
                                աշխատանքային օրվա ընթացքում Վաճառողին է ներկայացնում իր կողմից ստորագրված հանձնման-ընդունման արձանագրության մեկ օրինակը կամ ապրանքը չընդունելու պատճառաբանված մերժումը։
                                <br/><span style="margin-left: 25px;"/>5.4 Եթե պայմանագրի 5.3 կետով սահմանված ժամկետում Գնորդը չի ընդունում մատակարարված ապրանքը կամ չի մերժում դրա ընդունումը, ապա մատակարարված ապրանքը համարվում է ընդունված և պայմանագրի 5.3 կետով սահմանված վերջնաժամկետին հաջորդող աշխատանքային օրը Գնորդը Վաճառողին է տրամադրում իր կողմից ստորագրված հանձնման-ընդունման արձանագրությունը:
                        </template>
                    </div>
                </div>
                <br/>
                <div style="font-weight: 700; text-align: center;">6. ԿՈՂՄԵՐԻ ՊԱՏԱՍԽԱՆԱՏՎՈՒԹՅՈՒՆԸ</div>
                <br>
                <div class="info-block">
                    <div style="text-align: justify;">
                        <span style="margin-left: 25px;"/>6.1. Վաճառողը պատասխանատվություն է կրում հանձնած ապրանքի որակի և պայմանագրով նախատեսված մատակարարման ժամկետների պահպանման համար։
                        <br/><span style="margin-left: 25px;"/>6.2. Վաճառողի կողմից պայմանագրով նախատեսված ապրանքի մատակարարման ժամկետների խախտման դեպքում Վաճառողից յուրաքանչյուր ուշացված աշխատանքային օրվա համար գանձվում է տույժ` մատակարարման ենթակա, սակայն չմատակարարված ապրանքի գնի 0,05 (զրո ամբողջ հինգ հարյուրերրորդական) տոկոսի  չափով։
                        <br/><span style="margin-left: 25px;"/>6.3. Պայմանագրի 1.1 կետում նշված տեխնիկական բնութագրին չհամապատասխանող ապրանք մատակարարելու յուրաքանչյուր դեպքում Վաճառողից գանձվում է տուգանք` պայմանագրի գնի 0,5 (զրո ամբողջ հինգ տասնորդական) տոկոսի  չափով: Ընդ որում տուգանքը հաշվարկվում է նաև ապրանքի մատակարարումը սույն պայմանագրով սահմանված ժամկետում կատարելու, սակայն պատվիրատուի կողմից այդ չընդունվելու դեպքում: 
                        <br/><span style="margin-left: 25px;"/>6.4. Պայմանագրի 6.2 և 6.3 կետերով նախատեսված տույժը և տուգանքը հաշվարկվում և հաշվանցվում են Վաճառողին վճարման ենթակա գումարների հետ։
                        <br/><span style="margin-left: 25px;"/>6.5. Գնորդի կողմից պայմանագրի 3.2 կետով նախատեսված ժամկետի խախտման համար Գնորդի նկատմամբ յուրաքանչյուր ուշացված աշխատանքային օրվա համար հաշվարկվում է տույժ` վճարման ենթակա, սակայն չվճարված գումարի 0,05 (զրո ամբողջ հինգ հարյուրերրորդական) տոկոսի  չափով։
                        <br/><span style="margin-left: 25px;"/>6.6. Պայմանագրով չնախատեսված դեպքերում կողմերն իրենց պարտավորությունները չկատարելու կամ ոչ պատշաճ կատարելու համար պատասխանատվություն են կրում ՀՀ օրենսդրությամբ սահմանված կարգով։
                        <br/><span style="margin-left: 25px;"/>6.7. Տույժերի և (կամ) տուգանքի վճարումը Կողմերին չի ազատում իրենց պայմանագրային պարտվորությունները լրիվ կատարելուց։
                    </div>
                </div>
                <br/>
                <div style="font-weight: 700; text-align: center;">7. ԱՆՀԱՂԹԱՀԱՐԵԼԻ ՈՒԺԻ ԱԶԴԵՑՈՒԹՅՈՒՆԸ (ՖՈՐՍ-ՄԱԺՈՐ)</div>
                <br>
                <div class="info-block">
                    <div style="text-align: justify;">
                        <span style="margin-left: 25px;"/>Պայմանագրով պարտավորություններն ամբողջությամբ կամ մասնակիորեն չկատարելու համար կողմերն ազատվում են պատասխանատվությունից, եթե դա եղել է անհաղթահարելի ուժի ազդեցության հետևանքով, որը ծագել է սույն պայմանագիրը կնքելուց հետո, և որը կողմերը  չէին կարող կանխատեսել կամ կանխարգելել։ Այդպիսի իրավիճակներ են երկրաշարժը, ջրհեղեղը, հրդեհը, պատերազմը, ռազմական և արտակարգ դրություն հայտարարելը, քաղաքական հուզումները, գործադուլները, հաղորդակցության միջոցների աշխատանքի դադարեցումը, պետական մարմինների ակտերը և այլն, որոնք անհնարին են դարձնում սույն պայմանագրով պարտավորությունների կատարումը։ Եթե արտակարգ ուժի ազդեցությունը շարունակվում է 3 (երեք) ամսից ավելի, ապա կողմերից յուրաքանչյուրն իրավունք ունի լուծել պայմանագիրը` այդ մասին նախապես տեղյակ պահելով մյուս կողմին։
                    </div>
                </div>
                <br/>
                <div style="font-weight: 700; text-align: center;">8. ԱՅԼ ՊԱՅՄԱՆՆԵՐ</div>
                <br>
                <div class="info-block">
                    <h6 style="text-align: justify;">
                        <span style="margin-left: 25px;"/>8.1 Պայմանագիրն ուժի մեջ է մտնում Կողմերի ստորագրման պահից և գործում է մինչև կողմերի` պայմանագրով ստանձնած պարտավորությունների ողջ ծավալով կատարումը։
                        <template v-if="currentOrganized.rights_responsibilities_fulfillment">
                            <br/><span style="margin-left: 25px;"/>Պայմանագրով նախատեսված կողմերի իրավունքների և պարտականությունների կատարման պայման է հանդիսանում պայմանագիրը ՀՀ ֆինանսների նախարարության կողմից հաշվառված լինելու հանգամանքը:
                        </template>
                        <br/><span style="margin-left: 25px;"/>8.2. Պայմանագրից ծագած` կողմի վճարային պարտավորությունը չի կարող դադարել այլ պայմանագրից ծագած` հակընդդեմ պարտավորության հաշվանցով, առանց կողմերի գրավոր և կնիքով հաստատված համաձայնության։ Պայմանագրից ծագած պահանջի իրավունքը չի կարող փոխանցվել այլ անձի, առանց պարտապան կողմի գրավոր համաձայնության։
                        <br/><span style="margin-left: 25px;"/>8.3. Պայմանագրի հետ կապված վեճերը ենթակա են քննության Հայաստանի Հանրապետության դատարաններում։
                        <br/><span style="margin-left: 25px;"/>8.4. Պայմանագրում փոփոխություններ և լրացումներ կարող են կատարվել միայն Կողմերի փոխադարձ համաձայնությամբ:
                        <div class="is-agency-agreement">
                            <span style="color: rgb(17, 85, 204);">
                                <span style="margin-left: 25px;"/>8.5. Եթե պայմանագիրն  իրականացվում է գործակալության պայմանագիր կնքելու միջոցով.
                            </span>
                            <div style="color: rgb(17, 85, 204);">
                                <span style="margin-left: 25px;"/>1) Վաճառողը պատասխանատվություն է կրում գործակալի պարտավորությունների չկատարման կամ ոչ պատշաճ կատարման համար.
                            </div>
                            <div style="color: rgb(17, 85, 204);">
                                <span style="margin-left: 25px;"/>2) պայմանագրի կատարման ընթացքում գործակալի փոփոխման դեպքում Վաճառողը գրավոր տեղեկացնում է Գնորդին՝ տրամադրելով գործակալության պայմանագրի պատճենը և դրա կողմ հանդիսացող անձի տվյալները՝ փոփոխությունը կատարվելու օրվանից  հինգ աշխատանքային օրվա ընթացքում:
                            </div>
                            <div style="color: rgb(17, 85, 204);">
                                <span style="margin-left: 25px;"/>8.6. Եթե պայմանագիրն  իրականացվում է համատեղ գործունեության (կոնսորցիումի) պայմանագիր կնքելու միջոցով, ապա այդ պայմանագրի մասնակիցները կրում են համատեղ և համապարտ պատասխանատվություն: Ընդ որում, կոնսորցիումի անդամի կոնսորցիումից դուրս գալու դեպքում պայմանագիրը միակողմանիորեն լուծվում է և կոնսորցիումի անդամների նկատմամբ կիրառվում են պայմանագրով նախատեսված պատասխանատվության միջոցները:
                            </div>
                        </div>
                        <span style="margin-left: 25px;"/>8.7. Ապրանքի մատակարարման ժամկետը կարող է երկարաձգվել մինչև պայմանագրով այդ ժամկետը լրանալը` Վաճառողի առաջարկության առկայության դեպքում, պայմանով, որ Գնորդի մոտ չի վերացել ապրանքի օգտագործման պահանջը:
                        <br/><span style="margin-left: 25px;"/>8.8. Պայմանագրի պատշաճ կատարման պայմաններում կողմերի (Վաճառող կամ Գնորդ) օգուտները (խնայողություններ) կամ կրած վնասները տվյալ կողմի օգուտը կամ կրած վնասն են։
                        <br/><span style="margin-left: 25px;"/>Պայմանագրի կողմերի` երրորդ անձանց նկատմամբ պարտավորությունները՝ ներառյալ պայմանագրի կատարման շրջանակում Վաճառողի կնքած այլ գործարքները և դրանցից բխող պարտավորությունները, դուրս են պայմանագրի կարգավորման դաշտից և չեն կարող ազդել պայմանագրի կատարման արդյունքն ընդունելու վրա։ Այդ գործարքների և դրանցից բխող պարտավորությունների կատարման հետ կապված հարաբերությունները կարգավորվում են այդ գործարքների հետ կապված հարաբերությունները կարգավորող նորմերով, և դրանց համար պատասխանատու է Վաճառողը։
                        <br/><span style="margin-left: 25px;"/>8.9. Պայմանագրի կապակցությամբ ծագած վեճերը լուծվում են բանակցությունների միջոցով։ Համաձայնություն ձեռք չբերելու դեպքում վեճերը լուծվում են դատական կարգով։
                        <br/><span style="margin-left: 25px;"/>8.10. Սույն պայմանագիրը կազմված է <span class="pages-count">__</span> էջից, կնքվում է երկու օրինակից, որոնք ունեն հավասարազոր իրավաբանական ուժ, յուրաքանչյուր կողմին տրվում է մեկական օրինակ։ Պայմանագրի N 1, N 2, N 3 և N 3.1 հավելվածները, համարվում են պայմանագրի անբաժանելի մասը։
                        <br/><span style="margin-left: 25px;"/>8.11. Պայմանագրի հետ կապված հարաբերությունների նկատմամբ կիրառվում է Հայաստանի Հանրապետության իրավունքը։
                        <template v-if="currentOrganized.is_with_condition && currentOrganized.rows_total_price < 25000000" style="text-align: left">
                            <span style="color: rgb(17, 85, 204);">
                                <br/><span style="margin-left: 25px;"/>8.12 Պայմանագրով նախատեսված ապրանքների մատակարարումն իրականացվում է այդ նպատակով ֆինանսական միջոցների առկայության և դրա հիման վրա կողմերի միջև համապատասխան համաձայնագրի կնքման միջոցով: Պայմանագիրը լուծվում է, եթե այն կնքելու օրվան հաջորդող վեց ամսվա ընթացքում այդ նպատակով պայմանագրի կատարման համար ֆինանսական միջոցներ չեն նախատեսվում: Ընդ որում, Վաճառողը համաձայնագիրը կնքում և Գնորդին ներկայացնում է համաձայնագիր կնքելու ծանուցումը ստանալու օրվանից տասնհինգ աշխատանքային օրվա ընթացքում։ Հակառակ դեպքում պայմանագիրը Գնորդի կողմից միակողմանիորեն լուծվում է:
                            </span>
                        </template>
                        <template v-else-if="currentOrganized.is_with_condition" style="text-align: left">
                            <span style="color: rgb(17, 85, 204);">
                                <br/><span style="margin-left: 25px;"/>8.12. Պայմանագրով նախատեսված ապրանքների մատակարարումն իրականացվում է այդ նպատակով ֆինանսական միջոցների առկայության և դրա հիման վրա կողմերի միջև համապատասխան համաձայնագրի կնքման միջոցով: Պայմանագիրը լուծվում է, եթե այն կնքելու օրվան հաջորդող վեց ամսվա ընթացքում այդ նպատակով պայմանագրի կատարման համար ֆինանսական միջոցներ չեն նախատեսվում: Ընդ որում յուրաքանչյուր հաջորդ համաձայնագիրը կնքելու համար ֆինանսական միջոցների նախատեսման համար սույն կետով տրված վեցամսյա ժամանակահատվածի հաշվարկը սկսվում նախորդ համաձայնագրով սահմանված ապրանքի մատակարարման արդյունքը ողջ ծավալով պատվիրատուի կողմից ընդունվելու օրվանից: Եթե պայմանագրի կատարման համար հատկացված ֆինանսական միջոցների չափը գերազանցում է գնումների բազային միավորի քսանհինգապատիկը, ապա Գնորդի կողմից համաձայնագիր կկնքվի, եթե Վաճառողի կողմից տուժանքի ձևով ներկայացված որակավորման և պայմանագրի ապահովումները փոխարինվում են երաշխիքով կամ կանխիկ փողով` հաշվի առնելով ՀՀ կառավարության 2017 թվականի մայիսի 4-ի N 526-Ն որոշման N 1 հավելվածի 32-րդ կետի 1-ին ենթակետի «գ» և 17-րդ ենթակետի «բ» պարբերությունների պահանջները: Ընդ որում, Վաճառողը համաձայնագիրը կնքում, իսկ  տուժանքի ձևով ներկայացված որակավորման և պայմանագրի ապահովումների փոխարինման դեպքում նաև նոր ապահովները Գնորդին ներկայացնում է համաձայնագիր կնքելու ծանուցումը ստանալու օրվանից տասնհինգ աշխատանքային օրվա ընթացքում։ Հակառակ դեպքում պայմանագիրը Գնորդի կողմից միակողմանիորեն լուծվում է:
                            </span>
                        </template>
                    </h6>
                </div>
                <br/>
		        <div class="html2pdf__page-break"/>
                <div class="info-block">
                    <br>
                    <div style="text-align: center; font-weight: 700">
                        9. Կողմերի հասցեները, բանկային վավերապայմանները և ստորագրությունները
                    </div>
                    <br>
                    <div class="col-md-12 row d-flex justify-content-center info-block">
                        <table style="width: 100%; border: none !important">
                            <tbody>
                                <tr>
                                    <td style="border:none !important; width: 50%; text-align: center; padding-right: 10px;">
                                        <h6 class="ft-11" style="font-weight: 700">ԳՆՈՐԴ</h6>
                                        <p class="ft-11">« {{ me.organisation[0].translations.name.hy }} » {{ me.organisation[0].translations.company_type.hy }}</p>

                                        <p class="ft-11" v-if=" me.organisation[0].translations.region.hy === me.organisation[0].translations.city.hy "> {{ me.organisation[0].translations.city.hy }} {{ me.organisation[0].translations.address.hy }}</p>
                                        <p class="ft-11" v-else> {{ me.organisation[0].translations.region.hy }} {{ me.organisation[0].translations.city.hy }} {{ me.organisation[0].translations.address.hy }} </p>

                                        <p class="ft-11">Բանկ՝ {{ me.organisation[0].translations.bank_name.hy }}</p>
                                        <p class="ft-11">Հ/Հ {{ me.organisation[0].bank_account }} </p>
                                        <p class="ft-11">ՀՎՀՀ {{ me.organisation[0].tin }} </p>
                                        <p class="ft-11">Տնօրեն՝ {{ me.organisation[0].translations.director_name.hy }}</p>
                                        <p class="ft-11">______________________</p>
                                        <p>ստորագրություն</p>
                                    </td>
                                    <td style="border:none !important;padding-left: 10px; text-align: center; width: 50%;">
                                        <h6 class="ft-11" style="font-weight: 700">ՎԱՃԱՌՈՂ</h6>
                                        <p class="ft-11"><span class="winner-name">______________</span></p>
                                        <p class="ft-11"><span class="winner-address">_____________________</span></p>
                                        <p class="ft-11">Բանկ՝<span class="winner-bank">___________</span></p>
                                        <p class="ft-11">Հ/Հ <span class="winner-bank_account">_____________________</span></p>
                                        <p class="ft-11">ՀՎՀՀ <span class="winner-tin">______________</span></p>
                                        <p class="ft-11">Տնօրեն՝ <span class="winner-director">_____________________</span></p>
                                        <p class="ft-11">______________________</p>
                                        <p>ստորագրություն</p>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <h6 style="text-align: center; margin-bottom: 3rem">
                    Անհրաժեշտության դեպքում պայմանագրում կարող են ներառվել ՀՀ օրենսդրությանը չհակասող դրույթներ։
                    </h6>
                </div>
		        <div class="html2pdf__page-break"/>
                <pagebreak/> 
                <br class="page-break"/>
                <div class="info-block">
                    <h6 style="text-align: right; margin-top: 3rem">Հավելված  N 1</h6>
                    <h6 style="text-align: right"><span class="contract-code" style="color: rgb(17, 85, 204);"></span> ծածկագրով</h6>
                    <h6 style="text-align: right"><span style="color: rgb(17, 85, 204);"><span class="getContractType"></span></span> պայմանագրի</h6>
                    <h6 style="text-align: center; font-weight: 700">ՏԵԽՆԻԿԱԿԱՆ ԲՆՈՒԹԱԳԻՐ - ԳՆՄԱՆ ԺԱՄԱՆԱԿԱՑՈՒՅՑ*</h6>
                    <p style="text-align: right;">ՀՀ դրամ <span style="margin-left: 10px;"/></p> 
                    <table style="width: 100%;
                                  table-layout: fixed;
                                  border-collapse: collapse;
                                  page-break-inside: avoid;
                                  border: 1px solid  black;
                                  text-align: center;"  class="ft-5">
                        <tbody>
                            <tr>
                                <td colspan="10" style="border: 1px solid  black;
                                                        border-collapse: collapse;
                                                        text-align: center;">Ապրանքի</td>
                            </tr>
                            <tr>
                                <td rowspan="2" style="border: 1px solid  black;
                                                       border-collapse: collapse;
                                                       text-align: center;">Չ/Հ</td>
                                <td rowspan="2" style="border: 1px solid  black;
                                                       border-collapse: collapse;
                                                       text-align: center;">անվանումը</td>
                                <td rowspan="2" style="border: 1px solid  black;
                                                       border-collapse: collapse;
                                                       text-align: center;">տեխնիկական բնութագիրը</td>
                                <td rowspan="2" style="border: 1px solid  black;
                                                       border-collapse: collapse;
                                                       text-align: center;">չափման միավորը</td>
                                <td rowspan="2" style="border: 1px solid  black;
                                                       border-collapse: collapse;
                                                       text-align: center;">միավոր գինը/ՀՀ դրամ</td>
                                <td rowspan="2" style="border: 1px solid  black;
                                                       border-collapse: collapse;
                                                       text-align: center;">ընդհանուր գինը/ՀՀ դրամ</td>
                                <td rowspan="2" style="
                                            border: 1px solid  black;
                                            border-collapse: collapse;
                                            text-align: center;
                                    ">ընդհանուր քանակը</td>
                                <td colspan="3" style="
                                            border: 1px solid  black;
                                            border-collapse: collapse;
                                            text-align: center;
                                    ">մատակարարման</td>
                            </tr>
                            <tr>	
                                <td style="
                                            border: 1px solid  black;
                                            border-collapse: collapse;
                                            text-align: center;
                                    ">հասցեն</td>
                                <td style="
                                            border: 1px solid  black;
                                            border-collapse: collapse;
                                            text-align: center;
                                    ">ենթակա քանակը</td>
                                <td style="
                                            border: 1px solid  black;
                                            border-collapse: collapse;
                                            text-align: center;
                                    ">Ժամկետը</td>
                            </tr>
                        </tbody>
                        <tbody id="products-table-body" class="purchase-schedule">
                            <tr v-for="(row, rowIndex) in currentOrganized.organize_rows" :key="rowIndex">
                                <td style="
                                            border: 1px solid  black;
                                            border-collapse: collapse;
                                            text-align: center;
                                    ">{{ row.view_id }}</td>
                                <td style="
                                            border: 1px solid  black;
                                            border-collapse: collapse;
                                            text-align: center;
                                    ">{{ row.procurement_plan.cpv.name }}</td>
                                <td style="
                                            border: 1px solid  black;
                                            border-collapse: collapse;
                                            text-align: center;
                                    ">{{ row.procurement_plan.specifications.description.hy }}</td>
                                <td style="
                                            border: 1px solid  black;
                                            border-collapse: collapse;
                                            text-align: center;
                                    ">{{ row.procurement_plan.unit }}</td>
                                <td style="
                                            border: 1px solid  black;
                                            border-collapse: collapse;
                                            text-align: center;
                                    ">
                                </td>
                                <td style="
                                            border: 1px solid  black;
                                            border-collapse: collapse;
                                            text-align: center;
                                    ">
                                </td>
                                <td style="
                                            border: 1px solid  black;
                                            border-collapse: collapse;
                                            text-align: center;
                                    ">{{ row.count }}</td>
                                <td style="
                                            border: 1px solid  black;
                                            border-collapse: collapse;
                                            text-align: center;
                                    "
                                    v-if="me.organisation[0].translations.region.hy === me.organisation[0].translations.city.hy"
                                >
                                Ք.
                                    {{ me.organisation[0].translations.city.hy }}
                                    {{ me.organisation[0].translations.address.hy }}
                                </td>
                                <td style="
                                            border: 1px solid  black;
                                            border-collapse: collapse;
                                            text-align: center;
                                    "
                                    v-else
                                >
                                    {{ me.organisation[0].translations.region.hy }}

                                    ք.

                                    {{ me.organisation[0].translations.city.hy }}
                                    {{ me.organisation[0].translations.address.hy }}
                                </td>
                                <td style="
                                            border: 1px solid  black;
                                            border-collapse: collapse;
                                            text-align: center;
                                    ">{{row.supply || ''}}</td>
                                <td style="
                                            border: 1px solid  black;
                                            border-collapse: collapse;
                                            text-align: center;
                                    ">{{row.supply_date || ''}}</td>
                            </tr>
                        </tbody>
                    </table>
                    <p style="text-align: justify;">
                        <span style="color: rgb(17, 85, 204);">
                            Պայմանագրով նախատեսված դեպքում Վաճառողը Գնորդին ներկայացնում է նաև ապրանքն արտադրողից կամ վերջինիս ներկայացուցչից երաշխիքային նամակի կամ համապատասխանության սերտիֆիկատ:
                        </span>
                    </p>
                    <p style="text-align: justify;" v-if="currentOrganized.is_with_condition">
                        <span style="color: rgb(17, 85, 204);">
                            *** Եթե պայմանագիրը կնքվում է "Գնումների մասին" ՀՀ օրենքի 15-րդ հոդվածի 6-րդ մասի հիման վրա, ապա սյունակում ժամկետի հաշվարկը սահմանվում է օրացուցային օրերով՝ հաշվարկն իրականացնելով ֆինանսական միջոցներ նախատեսվելու դեպքում կողմերի միջև կնքվող համաձայնագրի ուժի մեջ մտնելու օրվանից:
                        </span>
                    </p>
                    <div class="col-md-12 row d-flex justify-content-center info-block">
                        <table style="width: 100%; border: none !important">
                            <tbody>
                                <tr>
                                    <td style="border:none !important; width: 50%; text-align: center; padding-right: 10px;">
                                        <h6 class="ft-11" style="font-weight: 700">ԳՆՈՐԴ</h6>
                                        <p class="ft-11">« {{ me.organisation[0].translations.name.hy }} » {{ me.organisation[0].translations.company_type.hy }}</p>

                                        <p class="ft-11" v-if=" me.organisation[0].translations.region.hy === me.organisation[0].translations.city.hy "> {{ me.organisation[0].translations.city.hy }} {{ me.organisation[0].translations.address.hy }}</p>
                                        <p class="ft-11" v-else> {{ me.organisation[0].translations.region.hy }} {{ me.organisation[0].translations.city.hy }} {{ me.organisation[0].translations.address.hy }} </p>

                                        <p class="ft-11">Բանկ՝ {{ me.organisation[0].translations.bank_name.hy }}</p>
                                        <p class="ft-11">Հ/Հ {{ me.organisation[0].bank_account }} </p>
                                        <p class="ft-11">ՀՎՀՀ {{ me.organisation[0].tin }} </p>
                                        <p class="ft-11">Տնօրեն՝ {{ me.organisation[0].translations.director_name.hy }}</p>
                                        <p class="ft-11">______________________</p>
                                        <p>ստորագրություն</p>
                                    </td>
                                    <td style="border:none !important;padding-left: 10px; text-align: center; width: 50%;">
                                        <h6 class="ft-11" style="font-weight: 700">ՎԱՃԱՌՈՂ</h6>
                                        <p class="ft-11"><span class="winner-name">______________</span></p>
                                        <p class="ft-11"><span class="winner-address">_____________________</span></p>
                                        <p class="ft-11">Բանկ՝<span class="winner-bank">___________</span></p>
                                        <p class="ft-11">Հ/Հ <span class="winner-bank_account">_____________________</span></p>
                                        <p class="ft-11">ՀՎՀՀ <span class="winner-tin">______________</span></p>
                                        <p class="ft-11">Տնօրեն՝ <span class="winner-director">_____________________</span></p>
                                        <p class="ft-11">______________________</p>
                                        <p>ստորագրություն</p>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
		        <div class="html2pdf__page-break"/>
                <pagebreak/> 
                <br class="page-break"/>
                <div class="info-block">
                    <h6 style="text-align: right; margin-top: 3rem">Հավելված  N 2</h6>
                    <h6 style="text-align: right"><span class="contract-code" style="color: rgb(17, 85, 204);"></span> ծածկագրով</h6>
                    <h6 style="text-align: right"><span style="color: rgb(17, 85, 204);"><span class="getContractType"></span></span> պայմանագրի</h6>
                    <br class="page-break"/>
                    <h6 style="margin-top: 3rem; text-align: center; font-weight: 700">
                        ՎՃԱՐՄԱՆ ԺԱՄԱՆԱԿԱՑՈՒՅՑ*
                    </h6>
                    <div style="text-align: right; ">ՀՀ դրամ <span style="margin-left: 20px;"/></div>
                    <table style=" 
                                width: 100%;
                                table-layout: fixed;
                                border-collapse: collapse;
                                page-break-inside: avoid;
                                border: 1px solid  black;
                                text-align: center;"> 
                        <thead>
                            <tr>
                                <th class="ft-11" style="border: 1px solid  black;
                                                                border-collapse: collapse;">Գնման առարկայի անվանումը</th>
                                <th class="ft-11" style="border: 1px solid  black;
                                                                border-collapse: collapse;">Վճարման ժամկետը</th>
                            </tr>
                        </thead>
                        <tbody class="payment-schedule">
                            <tr>
                                <td class="ft-11" style="
                                                border: 1px solid  black;
                                                border-collapse: collapse;
                                                padding: 20px;
                                                text-align: center;
                                        ">{{ currentOrganized.name }}</td>
                                <td class="ft-11" style="
                                                border: 1px solid  black;
                                                border-collapse: collapse;
                                                padding: 20px;
                                                text-align: justify;
                                        ">{{currentOrganized.payment_schedule_text}}</td>
                            </tr>
                        </tbody>
                    </table>  
                    <div class="col-md-12 row d-flex justify-content-center info-block">
                         <table style="width: 100%; border: none !important">
                            <tbody>
                                <tr>
                                    <td style="border:none !important; width: 50%; text-align: center; padding-right: 10px;">
                                        <h6 class="ft-11" style="font-weight: 700">ԳՆՈՐԴ</h6>
                                        <p class="ft-11">« {{ me.organisation[0].translations.name.hy }} » {{ me.organisation[0].translations.company_type.hy }}</p>

                                        <p class="ft-11" v-if=" me.organisation[0].translations.region.hy === me.organisation[0].translations.city.hy "> {{ me.organisation[0].translations.city.hy }} {{ me.organisation[0].translations.address.hy }}</p>
                                        <p class="ft-11" v-else> {{ me.organisation[0].translations.region.hy }} {{ me.organisation[0].translations.city.hy }} {{ me.organisation[0].translations.address.hy }} </p>

                                        <p class="ft-11">Բանկ՝ {{ me.organisation[0].translations.bank_name.hy }}</p>
                                        <p class="ft-11">Հ/Հ {{ me.organisation[0].bank_account }} </p>
                                        <p class="ft-11">ՀՎՀՀ {{ me.organisation[0].tin }} </p>
                                        <p class="ft-11">Տնօրեն՝ {{ me.organisation[0].translations.director_name.hy }}</p>
                                        <p class="ft-11">______________________</p>
                                        <p>ստորագրություն</p>
                                    </td>
                                    <td style="border:none !important;padding-left: 10px; text-align: center; width: 50%;">
                                        <h6 class="ft-11" style="font-weight: 700">ՎԱՃԱՌՈՂ</h6>
                                        <p class="ft-11"><span class="winner-name">______________</span></p>
                                        <p class="ft-11"><span class="winner-address">_____________________</span></p>
                                        <p class="ft-11">Բանկ՝<span class="winner-bank">___________</span></p>
                                        <p class="ft-11">Հ/Հ <span class="winner-bank_account">_____________________</span></p>
                                        <p class="ft-11">ՀՎՀՀ <span class="winner-tin">______________</span></p>
                                        <p class="ft-11">Տնօրեն՝ <span class="winner-director">_____________________</span></p>
                                        <p class="ft-11">______________________</p>
                                        <p>ստորագրություն</p>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
		        <div class="html2pdf__page-break"/>
                <pagebreak/>
                <br class="page-break"/>
                <div class="info-block">
                    <h6 style="text-align: right; margin-top: 3rem">Հավելված  N 3</h6>
                    <h6 style="text-align: right"><span class="contract-code" style="color: rgb(17, 85, 204);"></span> ծածկագրով</h6>
                    <h6 style="text-align: right"><span style="color: rgb(17, 85, 204);"><span class="getContractType"></span></span> պայմանագրի</h6>
                    <div class="col-md-12 d-flex" style="margin-top: 3rem">
                        <table style="width: 100%; border: none !important">
                            <tbody>
                                <tr>
                                    <td style="border:none !important; text-align: right; width: 50%; padding-right: 10px;">
                                        <p class="ft-11" style="font-weight: 700">Պայմանագրի կողմ </p>
                                        <p class="ft-11" >_____________________________ </p>
                                        <p class="ft-11" >_____________________________ </p>
                                        <p class="ft-11" >գտնվելու վայրը__________</p>
                                        <p class="ft-11" >հհ __________________________</p>
                                        <p class="ft-11" >հվհհ _______________________ </p>
                                    </td>
                                    <td style="text-align: left;border:none !important;padding-left: 10px; width: 50%;">	
                                        <p class="ft-11" style="font-weight: 700">Պատվիրատու</p>
                                        <p class="ft-11" >_____________________________ </p>
                                        <p class="ft-11" >_____________________________ </p>
                                        <p class="ft-11" >գտնվելու վայրը__________</p>
                                        <p class="ft-11" >հհ __________________________</p>
                                        <p class="ft-11" >հվհհ _______________________ </p>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
		        <div class="html2pdf__page-break"/>
                <div class="info-block">
                    <h6 style="font-weight: 700; text-align: center; margin-top: 3rem">ԱՐՁԱՆԱԳՐՈՒԹՅՈՒՆ N</h6>
                    <h6 style="font-weight: 700; text-align: center">ՊԱՅՄԱՆԱԳՐԻ ԿԱՄ ԴՐԱ ՄԻ ՄԱՍԻ ԿԱՏԱՐՄԱՆ ԱՐԴՅՈՒՆՔՆԵՐԻ</h6>
                    <h6 style="font-weight: 700; text-align: center">ՀԱՆՁՆՄԱՆ-ԸՆԴՈՒՆՄԱՆ</h6>
                    <p>«_______» «____________» 20 թ.</p>
                    <p>Պայմանագրի <span style="margin-left: 25px;" />/այսուհետ`<span style="margin-left: 25px;" /> Պայմանագիր/ <span style="margin-left: 25px;" />անվանումը` </p>
                    <p>______________________________________________________________________________________</p>
                    <p>Պայմանագրի կնքման ամսաթիվը` «_______» «____________» 20 թ.</p>
                    <p>Պայմանագրի համարը`___________________</p>
                    <p style="text-align: justify;">Պատվիրատուն  և  Պայմանագրի կողմը՝  հիմք  ընդունելով  պայմանագրի  կատարման  վերաբերյալ  «_______» «____________» 20 թ. դուրս գրված N___   հաշիվ ապրանքագիրը, կազմեցին սույն արձանագրությունը հետևյալի մասին.</p>
                    <p>Պայմանագրի շրջանակներում Պայմանագրի կողմը  մատակարարել է հետևյալ ապրանքները՝</p>
                    <table style="width: 100%;
                                table-layout: fixed;
                                border-collapse: collapse;
                                page-break-inside: avoid;
                                border: 1px solid  black;
                                text-align: center;">
                            <tbody><tr>
                                <th rowspan="3" style=" border: 1px solid  black;
                                                        border-collapse: collapse;">N</th>
                                <th colspan="8" style=" border: 1px solid  black;
                                                        border-collapse: collapse;">Մատակարարված ապրանքների</th>
                            </tr>
                            <tr>
                                <th rowspan="2" style=" border: 1px solid  black;
                                                        border-collapse: collapse;">անվանումը</th>
                                <th rowspan="2" style=" border: 1px solid  black;
                                                        border-collapse: collapse;">տեխնիկական բնութագրի համառոտ շարադրանքը</th>
                                <th colspan="2" style=" border: 1px solid  black;
                                                        border-collapse: collapse;">քանակական ցուցանիշը
                                </th>
                                <th colspan="2" style=" border: 1px solid  black;
                                                        border-collapse: collapse;">կատարման ժամկետը</th>
                                <th rowspan="2" style=" border: 1px solid  black;
                                                        border-collapse: collapse;">Վճարման ենթակա գումարը /հազար դրամ/</th>
                                <th rowspan="2" style=" border: 1px solid  black;
                                                        border-collapse: collapse;">Վճարման ժամկետը /ըստ վճարման ժամանակացույցի/</th>
                            </tr>
                            <tr>
                                <th style=" border: 1px solid  black;
                                            border-collapse: collapse;">պայմանագրով հաստատված գնման ժամանակացույցի</th>
                                <th style=" border: 1px solid  black;
                                            border-collapse: collapse;">փաստացի</th>
                                <th style=" border: 1px solid  black;
                                            border-collapse: collapse; ">ըստ պայմանագրով հաստատված գնման ժամանակացույցի</th>
                                <th style=" border: 1px solid  black;
                                            border-collapse: collapse;">փաստացի
                                </th>
                            </tr>
                            <tr>
                                <td style="
    
                                        border: 1px solid  black;
                                        border-collapse: collapse;
                                        height: 30px;
                                        text-align: center;
                                "></td>
                                <td style="
    
                                        border: 1px solid  black;
                                        border-collapse: collapse;
                                        height: 30px;
                                        text-align: center;
                                "></td>
                                <td style="
    
                                        border: 1px solid  black;
                                        border-collapse: collapse;
                                        height: 30px;
                                        text-align: center;
                                "></td>
                                <td style="
    
                                        border: 1px solid  black;
                                        border-collapse: collapse;
                                        height: 30px;
                                        text-align: center;
                                "></td>
                                <td style="
    
                                        border: 1px solid  black;
                                        border-collapse: collapse;
                                        height: 30px;
                                        text-align: center;
                                "></td>
                                <td style="
    
                                        border: 1px solid  black;
                                        border-collapse: collapse;
                                        height: 30px;
                                        text-align: center;
                                "></td>
                                <td style="
    
                                        border: 1px solid  black;
                                        border-collapse: collapse;
                                        height: 30px;
                                        text-align: center;
                                "></td>
                                <td style="
    
                                        border: 1px solid  black;
                                        border-collapse: collapse;
                                        height: 30px;
                                        text-align: center;
                                "></td>
                                <td style="
    
                                        border: 1px solid  black;
                                        border-collapse: collapse;
                                        height: 30px;
                                        text-align: center;
                                "></td>
                            </tr>
                            <tr>
                                <td style="
    
                                        border: 1px solid  black;
                                        border-collapse: collapse;
                                        height: 30px;
                                        text-align: center;
                                "></td>
                                <td style="
    
                                        border: 1px solid  black;
                                        border-collapse: collapse;
                                        height: 30px;
                                        text-align: center;
                                "></td>
                                <td style="
    
                                        border: 1px solid  black;
                                        border-collapse: collapse;
                                        height: 30px;
                                        text-align: center;
                                "></td>
                                <td style="
    
                                        border: 1px solid  black;
                                        border-collapse: collapse;
                                        height: 30px;
                                        text-align: center;
                                "></td>
                                <td style="
    
                                        border: 1px solid  black;
                                        border-collapse: collapse;
                                        height: 30px;
                                        text-align: center;
                                "></td>
                                <td style="
    
                                        border: 1px solid  black;
                                        border-collapse: collapse;
                                        height: 30px;
                                        text-align: center;
                                "></td>
                                <td style="
    
                                        border: 1px solid  black;
                                        border-collapse: collapse;
                                        height: 30px;
                                        text-align: center;
                                "></td>
                                <td style="
    
                                        border: 1px solid  black;
                                        border-collapse: collapse;
                                        height: 30px;
                                        text-align: center;
                                "></td>
                                <td style="
    
                                        border: 1px solid  black;
                                        border-collapse: collapse;
                                        height: 30px;
                                        text-align: center;
                                "></td>
                            </tr>
                        </tbody>
                    </table>
                    <p style="text-align: justify;"> Սույն արձանագրության երկկողմ հաստատման համար հիմք հանդիսացած հաշիվ ապրանքագիրը և դրական եզրակացությունը հանդիսանում են սույն արձանագրության բաղկացուցիչ մասը և կցվում են:</p>
                    <div style="margin-bottom: 3rem">
                        <table style="width: 100%; border: none !important">
                            <tbody>
                                <tr>
                                    <td style="border:none !important;">
                                        <div style="margin-top: 1.5rem; text-align: center">
                                            <h6 style=" font-weight: 700">Ապրանքը հանձնեց</h6>
                                            <p style="font-weight: 700; margin-top: 1.5rem">	_________________________________</p>
                                            <p>/ստորագրություն/</p>
                                            <p style="font-weight: 700; margin-top: 1.5rem">	_________________________________</p>
                                            <p>ազգանուն, անուն</p>
                                        </div>
                                    </td>
                                    <td style="border:none !important;">
                                        <div style="margin-top: 1.5rem; text-align: center">
                                            <h6 style="font-weight: 700">Ապրանքը ընդունեց</h6>
                                            <p style="font-weight: 700; margin-top: 1.5rem">	_________________________________</p>
                                            <p>/ստորագրություն/</p>
                                            <p style="font-weight: 700; margin-top: 1.5rem">	_________________________________</p>
                                            <p>ազգանուն, անուն</p>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
		        <div class="html2pdf__page-break"/>
                <pagebreak/> 
                <br class="page-break"/>
                <div class="info-block">
                    <h6 style="text-align: right; margin-top: 3rem">Հավելված  N 3.1</h6>
                    <h6 style="text-align: right"><span class="contract-code" style="color: rgb(17, 85, 204);"></span> ծածկագրով</h6>
                    <h6 style="text-align: right"><span style="color: rgb(17, 85, 204);"><span class="getContractType"></span></span> պայմանագրի</h6>

                    <div style="text-align: center; font-weight: 700">ԱԿՏ N</div>
                    <div style="text-align: center; font-weight: 700">պայմանագրի արդյունքը Գնորդին հանձնելու փաստը ֆիքսելու վերաբերյալ </div>
                    <br>
                    <p>                
                        <table style="border: 0 !important">
                            <tr style="border: 0 !important">
                                <td style="border: 0 !important">Սույնով արձանագրվում է, որ</td>
                                <td style="border: 0 !important">_____________________________</td>
                                <td style="border: 0 !important">-ի (այսուհետ` Պատվիրատու) և </td>
                                <td style="border: 0 !important">_______________________________________</td>
                                <td style="border: 0 !important">-ի</td>
                            </tr>
                            <tr style="border: 0 !important">
                                <td style="border: 0 !important"></td>
                                <td style="text-align: center; font-size: 8px;border: 0 !important">Պատվիրատուի անունը</td>
                                <td style="border: 0 !important"></td>
                                <td style="text-align: center; font-size: 8px;border: 0 !important">Կատարողի անունը</td>
                                <td style="border: 0 !important"></td>
                            </tr>
                        </table>
                    </p>
                    <p>                
                        <table style="border: 0 !important">
                            <tr style="border: 0 !important">
                                <td style="border: 0 !important">(այսուհետ` Վաճառող) միջև 20__թ.</td>
                                <td style="border: 0 !important">_________________________</td>
                                <td style="border: 0 !important">-ին կնքված N</td>
                                <td style="border: 0 !important">_________________________________________________</td>
                            </tr>
                            <tr style="border: 0 !important">
                                <td style="border: 0 !important"></td>
                                <td style="border: 0 !important;text-align: center; font-size: 8px;">պայմանագրի կնքման ամսաթիվը</td>
                                <td style="border: 0 !important"></td>
                                <td style="border: 0 !important;text-align: center; font-size: 8px;">պայմանագրի համարը</td>
                            </tr>
                        </table>
                    </p>	
                    <p>պայմանագրի շրջանակներում Վաճառողը  20__թ.__________________-ին հանձնման-ընդունման նպատակով </p>
                    <p>Գնորդին հանձնեց ստորև նշված ապրանքները.</p>
                    <table style="width: 100%;
                                 
                                table-layout: fixed;
                                page-break-inside: avoid;
                                border: 1px solid  black;
                                border-collapse: collapse;
                                text-align: center;">
                        <tbody><tr>
                            <th colspan="3" style="border: 1px solid  black;
                                                   border-collapse: collapse;">Ապրանքի</th>
                        </tr>
                        <tr>
                            <th style="border: 1px solid  black;
                                       border-collapse: collapse;">անվանումը</th>
                            <th style="border: 1px solid  black;
                                       border-collapse: collapse;">չափման միավորը</th>
                            <th style="border: 1px solid  black;
                                       border-collapse: collapse;">քանակը (փաստացի)</th>
                        </tr>
                        <tr>
                            <td style="padding:20px;    
                                        border: 1px solid  black;
                                        border-collapse: collapse;
                                        text-align: center;"
                            ></td>
                            <td style="padding:20px;
                                        border: 1px solid  black;
                                        border-collapse: collapse;
                                        text-align: center;"></td>
                            <td style="padding:20px;
                                        border: 1px solid  black;
                                        border-collapse: collapse;
                                        text-align: center;"></td>
                        </tr>
                        <tr>
                            <td style="padding:20px;
                                        border: 1px solid  black;
                                        border-collapse: collapse;
                                        text-align: center;"></td>
                            <td style="padding:20px;
                                        border: 1px solid  black;
                                        border-collapse: collapse;
                                        text-align: center;">
                            </td>
                            <td style="padding:20px;
                                        border: 1px solid  black;
                                        border-collapse: collapse;
                                        text-align: center;"></td>
                        </tr>
                    </tbody></table>
                    <h6>Սույն ակտը կազմված է 2 օրինակից, յուրաքանչյուր կողմին տրամադրվում է մեկական օրինակ:</h6>
                    <div style="margin-bottom: 3rem">
                        <table style="width: 100%; border: none !important">
                            <tbody>
                                <tr>
                                    <td style="border:none !important;">
                                        <div>
                                            <h6 style="text-align: center; font-weight: 700;">Ապրանքը հանձնեց<span style="margin-left: 25px;"/></h6>
                                            <p style="text-align: center; font-weight: 700;">	__________________________________</p>
                                            <p style="text-align: center">ազգանուն, անուն </p>
                                            <p style="text-align: center; font-weight: 700;">	__________________________________</p>
                                            <p style="text-align: center">/ստորագրություն/ </p>
                                        </div>
                                    </td>
                                    <td style="border:none !important;">
                                        <div>
                                            <h6 style="text-align: center; font-weight: 700">Ընդունեց <br> հայտը նախագծած ներկայացուցիչ`</h6>
                                            <p style="text-align: center; font-weight: 700;">	__________________________________</p>
                                            <p style="text-align:center;">ազգանուն, անուն
                                            <p style="text-align: center; font-weight: 700;">	__________________________________</p>
                                            <p style="text-align: center;">/ստորագրություն/</p>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import purchaseTypesLongNamesCased from '@/mixins/purchaseTypes'
import $ from 'jquery';

export default {
    name: 'contract_draft_product',
    mixins: [purchaseTypesLongNamesCased],
    components: {  },
    props: ['handleLoaded'],
    data() {
        return {
            inputs: {
                work_type: null,
                option1: '',
                copyCount: null,
                daysCount: null,
                violationDays: null,
                violationDays_1: null,
                violationDays_2: null,
                workersCount: null,
                pagesCount: null,
            },
            participants: [],
            getOrgnizeTypeByPlan: '',
            participantsSequence: [],
            totalMembers: 0,
        }
    },
    validations() {
        const rules = {
            inputs: {
                violationDays: { required },
                violationDays_1: { required },
                violationDays_2: {},
                workersCount: { required },
                daysCount: { required }
            }
        }
        if(+this.currentOrganized.organize_type === 0){
            Object.assign(rules.inputs, {
                copyCount: { required },
            })
        }
        return rules;
    },
    mounted() { 
        const locale = 'hy'
        // this.purchaseType = this.organizedRows[0].type
        this.getOrgnizeTypeByPlan = this.purchaseTypesLongNamesCased[locale][this.purchaseType || 2]
    },
    computed: {
        currentOrganized() {
            return this.$store.getters['organizeItender/currentOrganized']
        },
        organizedRows() {
            return this.currentOrganized.organize_rows
        },
        userChildren() {
            return this.$store.getters['user/userChildren']
        },
        me() {
            return this.$store.getters['user/me']
        },
    },
    watch: {
        currentOrganized: {
            immediate: true,
            async handler() {
                this.handleLoaded()
            },
        },
    },
    methods: {
        async save() {            
            this.$v.inputs.$touch();
            const _this = this
            let hasInvalid = false;
            $('#commandment-file .editor-input').each(function() {
                const inputName = $(this).attr('inputname');
                const input = _this.$v.inputs[inputName];
                if (input.$error) {
                    hasInvalid = true;
                    if(_this.$refs[inputName]._isVue) {
                        _this.$refs[inputName].$el.focus()
                    } else {
                        _this.$refs[inputName].focus();
                    }
                    return false;
                }
            });
            if(!hasInvalid){
                $('.editor-input').each(function() {
                    const txt = $(this).val()
                    $(this).after(txt)
                    $(this).remove()
                });

                $('.editor-option').each(function(index) {
                    const inputNumber = index+1
                    const optionValue = $(`.option-${inputNumber}:checked`).val()
                    const notSelectedOptionValue = +optionValue === 1 ? 2 : 1
                    $(`.option-${inputNumber}-variant-${notSelectedOptionValue}`).remove()
                    $(`.option-${inputNumber}`).remove()
                });
                this.$store.dispatch('organizeItender/update', {id: this.$route.params.id, data: { contract_html_hy: $('#commandment-file').html() }}).then(async(response) => {
                    if(response) {
                        this.$notify({
                            group: 'foo',
                            type: 'success',
                            text: 'Հաջողությամբ պահպանված է'
                        })
                        await this.$modal.hide('new-editor-modal')
                    }
                    this.isSaving = false
                }).catch(e => {
                    this.$notify({
                        group: 'foo',
                        type: 'error',
                        title: 'Ինչ որ բան այն չէ',
                        text: 'Կրկին փորձեք!'
                    })
                    this.isSaving = false
                })
            }
        },
        consoleLog(msg) {
            console.log(msg)
        },
        calculateMonthPrice(price, percent){
            return price*percent/100
        },
    },
}
</script>
<style>
.option-box *{
    color: grey;
}
.option-box-selected *{
    color: red;
}
</style>
<style scoped>
    *{
        font-family: GHEA grapalat  !important;
    }
</style>